import $ from 'jquery';

class MyNotes{
    constructor(){
        this.events();
    }

    events(){

        // the second argument for .delete-note, .edit-note, .update-note  is to make buttons ready to ble clicked once
        // the new post entry will pop up
        $("#my-notes").on("click",".delete-note", this.deleteNote);

        // make sure that .bind(this) method refers to the correct instance of the MyNotes class.
        $("#my-notes").on("click", ".edit-note", this.editNote.bind(this));

        // make sure that .bind(this) method refers to the correct instance of the MyNotes class.
        $("#my-notes").on("click", ".update-note", this.updateNote.bind(this));



        $(".submit-note").on("click", this.createNote.bind(this));
    }

    // Methods will go here

    deleteNote(event){
        // (event) - parameter is to access elements to this function  

        // Target specific list item from a custom HTML attribute (<li data-id="<?php the_ID(); ?>"> at page-my-notes.php)
        var thisNote = $(event.target).parents("li");

        // initialze ajax to execute DELETE request
        // universityData is taken from functions.php and specified in associative array 'root_url' => get_site_url()
        // console.log(universityData.root_url);
        $.ajax({

            // Include Nonce to prove WordPress to make those requests
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', universityData.nonce);
            },

            // thisNote.data('id') ---> var thisNote = $(event.target).parents("li");
            url: universityData.root_url + '/wp-json/wp/v2/note/' + thisNote.data('id'),
            type: 'DELETE',

            success: (response) => {
                // Slide effect when the note is removed
                thisNote.slideUp();

                console.log("Congrats");
                console.log(response);

                // Remove warning text when post limit is reduced 
                if(response.userNoteCount < 5){
                    $(".note-limit-message").removeClass("active");
                }
            },
            error: (response) => {
                console.log("Sorry");
                console.log(response);
            }
        });
        
    }



    updateNote(event){
        // (event) - parameter is to access elements to this function  

        // Target specific list item from a custom HTML attribute (<li data-id="<?php the_ID(); ?>"> at page-my-notes.php)
        var thisNote = $(event.target).parents("li");


        // Get the right data value from selected HTML objects.
        // ourUpdatedPost will be passed to $.ajax({}) 'POST' request 
        var ourUpdatedPost = {
            'title': thisNote.find(".note-title-field").val(),
            'content': thisNote.find(".note-body-field").val()
        }

        // initialze ajax to execute POST request
        // universityData is taken from functions.php and specified in associative array 'root_url' => get_site_url()
        // console.log(universityData.root_url);
        $.ajax({

            // Include Nonce to prove WordPress to mage those requests
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', universityData.nonce);
            },

            // thisNote.data('id') ---> var thisNote = $(event.target).parents("li");
            url: universityData.root_url + '/wp-json/wp/v2/note/' + thisNote.data('id'),
            type: 'POST',

            data: ourUpdatedPost, 

            success: (response) => {
                // Execute makeNoteReadOnly(thisNote) method only after editing
                this.makeNoteReadOnly(thisNote);

                console.log("Congrats");
                console.log(response);
            },
            error: (response) => {
                console.log("Sorry");
                console.log(response);
            }
        });
        
    }




    createNote(event){
        // (event) - parameter is to access elements to this function  


        // Get the right data value from selected HTML objects.
        // ourUpdatedPost will be passed to $.ajax({}) 'POST' request 
        var ourNewPost = {
            'title': $(".new-note-title").val(),
            'content': $(".new-note-body").val(),

            // make post automatically publish
            'status': 'publish'
        }

        // initialze ajax to execute POST request
        // universityData is taken from functions.php and specified in associative array 'root_url' => get_site_url()
        // console.log(universityData.root_url);
        $.ajax({

            // Include Nonce to prove WordPress to make those requests
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', universityData.nonce);
            },

            // thisNote.data('id') ---> var thisNote = $(event.target).parents("li");
            url: universityData.root_url + '/wp-json/wp/v2/note/',
            type: 'POST',

            data: ourNewPost, 

            success: (response) => {
                // Clear out posts fields from the form when adding a new post
                $(".new-note-title, .new-note-body").val('');

                // Add the the HTML for new created post by using prependTo("#my-notes").hide().slideDown() Jquery methods
                $(`
                <li data-id="${response.id}">
                        <input readonly class="note-title-field" value="${response.title.raw}">
                        <span class="edit-note"><i class="fa fa-pencil" aria-hidden="true"></i> Edit</span>
                        <span class="delete-note"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete</span>
                        <textarea readonly class="note-body-field">${response.content.raw}</textarea>

                        <span class="update-note btn btn--blue btn--small"><i class="fa fa-arrow-right" aria-hidden="true"></i> Save</span>
                </li>
                `).prependTo("#my-notes").hide().slideDown();

                console.log("Congrats");
                console.log(response);
            },
            error: (response) => {
                // If reached post limit by response text
                if(response.responseText == "You have reached your note limit."){
                    $(".note-limit-message").addClass("active");
                }
                console.log("Sorry");
                console.log(response);
            }
        });
        
    }



        editNote(event){
             // Target specific list item from a custom HTML attribute (<li data-id="<?php the_ID(); ?>"> at page-my-notes.php)
            var thisNote = $(event.target).parents("li");

            // check if html for span has correct attributes to swith between edit/cancell
            if(thisNote.data("state") == "editable"){
                this.makeNoteReadOnly(thisNote);
            }else{
                this.makeNoteEditable(thisNote);
            }

            
        }

        makeNoteEditable(thisNote){
            // Replace the button content when the edit is clicked
            thisNote.find(".edit-note").html('<i class="fa fa-times" aria-hidden="true"></i> Cancel');

            // Find and remove an HTML attribute called "readonly" and add custom class
            thisNote.find(".note-title-field, .note-body-field").removeAttr("readonly").addClass("note-active-field");

            // Add Class 
            thisNote.find(".update-note").addClass("update-note--visible");

            // Assign html attribute 
            thisNote.data("state", "editable");
        }

        makeNoteReadOnly(thisNote){
            // Replace the button content when the edit is clicked
            thisNote.find(".edit-note").html('<i class="fa fa-pencil" aria-hidden="true"></i> Edit');

            // Find and add an HTML attribute called "readonly" and add custom class
            thisNote.find(".note-title-field, .note-body-field").attr("readonly", "readonly").removeClass("note-active-field");

            // Add Class 
            thisNote.find(".update-note").removeClass("update-note--visible");

            // Assign html attribute
            thisNote.data("state", "cancell");
        }
}

export default MyNotes;